































































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class FooterDisclaimer extends Vue {
	@Prop({ default: false })
	footerFull!: boolean;

	appBasePath = process.env.VUE_APP_BASE_PATH;

	get currentYear(): number {
		const today = new Date();
		return today.getFullYear();
	}
}
